import React from 'react';
import { Dialog, DialogContent, Typography, Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, Paper, Button } from '@mui/material';
import MaliyeLogo from "../../../../assets/images/logos/maliyeLogo.png";
export default function InvoicePreviewPopUpModal({ openDialog, handleCloseDialog, invoiceData }) {
 
  if (!invoiceData) {
    return (
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogContent>
          <Typography>Fatura verisi bulunamadı.</Typography>
        </DialogContent>
      </Dialog>
    );
  }

  const BorderedPaper = ({ children, ...props }) => (
    <Paper 
      {...props} 
      elevation={0} 
      sx={{ 
        border: '1px solid black', 
        height: '100%',
        padding: 1,
        ...props.sx
      }}
    >
      {children}
    </Paper>
  );

  const handlePrint = () => {
    document.title = `Fatura-${safeDisplay(invoiceData?.number)}`;
    window.print();
  };

  const safeDisplay = (value, defaultValue = '-') => {
    return value || defaultValue;
  };

  const safeFormatDate = (dateString) => {
    if (!dateString || dateString.includes('0001-01-01')) return '-';
    try {
      return new Date(dateString).toLocaleDateString('tr-TR');
    } catch {
      return '-';
    }
  };
  const getCustomerInfo = () => {
    if (invoiceData.userOfCustomer) {
      return {
        name: invoiceData.userOfCustomer.title,
        address: invoiceData.userOfCustomer.address,
        district: invoiceData.userOfCustomer.district,
        city: invoiceData.userOfCustomer.city,
        phone: invoiceData.userOfCustomer.phoneNumber,
        email: invoiceData.userOfCustomer.email,
        identityNumber: invoiceData.userOfCustomer.identityNumber
      };
    } else if (invoiceData.order) {
      return {
        name: `${invoiceData.order.customerFirstName} ${invoiceData.order.customerLastName}`,
        email: invoiceData.order.customerEmail,
        identityNumber:invoiceData.order.taxNumber|| invoiceData.order.tcIdentityNumber
      };
    }
    return {};
  };

  const customerInfo = getCustomerInfo();

  return (
    <Dialog 
      open={openDialog} 
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth
    >
      <Button 
        variant="contained" 
        onClick={handlePrint} 
        sx={{ 
          m: 1,
          width: 100,
          '@media print': {
            display: 'none',
          }
        }}
      >
        Çıktı Al
      </Button>
      <DialogContent
  sx={{
    padding: 2,
    maxHeight: '90vh',
    overflowY: 'auto',
    '@media print': {
      maxHeight: 'none',
      overflowY: 'visible',
    },
  }}
>
        <Box>
          {/* Header Section */}
          <Grid container spacing={2}>
          
            <Grid item xs={6}>
              <BorderedPaper sx={{ textAlign: 'center' }}>
                <img src={MaliyeLogo} alt="Maliye Logo"  style={{ width: 90,marginTop:4 }} />
                <Typography variant="h6">e-Arşiv Fatura</Typography>
              </BorderedPaper>
            </Grid>
            <Grid item xs={6}>
              <BorderedPaper>
                <Typography>Fatura No: {safeDisplay(invoiceData.number)}</Typography>
                <Typography>Fatura Tarihi: {safeFormatDate(invoiceData.issueDate)}</Typography>
                <Typography>ETTN: {safeDisplay(invoiceData.ettn)}</Typography>
                <Typography>Para Birimi: {safeDisplay(invoiceData.currencyCode)}</Typography>
              </BorderedPaper>
            </Grid>
          </Grid>

          {/* Customer Information */}
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <BorderedPaper>
                <Typography variant="h6">SAYIN</Typography>
                <Typography>{safeDisplay(customerInfo.name)}</Typography>
                {customerInfo.address && <Typography>{customerInfo.address}</Typography>}
                {(customerInfo.district || customerInfo.city) && (
                  <Typography>
                    {safeDisplay(customerInfo.district)}
                    {customerInfo.city ? `, ${customerInfo.city}` : ''}
                  </Typography>
                )}
                {customerInfo.phone && <Typography>Tel: {customerInfo.phone}</Typography>}
                <Typography>E-Posta: {safeDisplay(customerInfo.email)}</Typography>
              </BorderedPaper>
            </Grid>
            <Grid item xs={6}>
              <BorderedPaper>
                <Typography>
                  {invoiceData.order?.commercial ? 'Vergi No' : 'TC Kimlik No'}: 
                  {safeDisplay(customerInfo.identityNumber)}
                </Typography>
                <Typography>Son Ödeme: {safeFormatDate(invoiceData.paymentDueDate)}</Typography>
                {invoiceData.order && (
                  <>
                    <Typography>Sipariş No: {safeDisplay(invoiceData.order.orderNumber)}</Typography>
                    <Typography>Kargo Firması: {safeDisplay(invoiceData.order.cargoProviderName)}</Typography>
                    <Typography>Takip No: {safeDisplay(invoiceData.order.cargoTrackingNumber)}</Typography>
                  </>
                )}
              </BorderedPaper>
            </Grid>
          </Grid>

          {/* Invoice Items Table */}
          <BorderedPaper sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Mal/Hizmet</TableCell>
                  <TableCell align="right">Miktar</TableCell>
                  <TableCell align="right">Birim Fiyat</TableCell>
                  <TableCell align="right">İndirim</TableCell>
                  <TableCell align="right">KDV</TableCell>
                  <TableCell align="right">Toplam</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(invoiceData.invoiceLines || []).map((line, index) => (
                  <TableRow key={index}>
                    <TableCell>{safeDisplay(line.inventoryCard)}</TableCell>
                    <TableCell align="right">{safeDisplay(line.quantity)}</TableCell>
                    <TableCell align="right">
                      {safeDisplay(line.unitPrice)} {safeDisplay(invoiceData.currencyCode)}
                    </TableCell>
                    <TableCell align="right">%{safeDisplay(line.discountRate, 0)}</TableCell>
                    <TableCell align="right">%{safeDisplay(line.vatRate, 0)}</TableCell>
                    <TableCell align="right">
                      {safeDisplay(line.lineExtensionAmount)} {safeDisplay(invoiceData.currencyCode)}
                    </TableCell>
                  </TableRow>
                ))}
                {(!invoiceData.invoiceLines || invoiceData.invoiceLines.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">Fatura kalemi bulunamadı</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </BorderedPaper>

          {/* Totals */}
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <BorderedPaper sx={{ width: '900px' }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Toplam Tutar</TableCell>
                    <TableCell align="right">
                      {safeDisplay(invoiceData?.totalAmount)} {safeDisplay(invoiceData?.currencyCode)}
                    </TableCell>
                  </TableRow>
                 
                       
                  <TableRow>
  <TableCell>Toplam İndirim Tutarı</TableCell>
  <TableCell align="right">
    {((invoiceData.invoiceLines || []).reduce((sum, line) => 
      sum + (line.discountAmount || 0), 0))?.toFixed(2)} {safeDisplay(invoiceData?.currencyCode)}
  </TableCell>
</TableRow>

                  {invoiceData.order && (
                    <>
                      <TableRow>
                        <TableCell>Brüt Tutar</TableCell>
                        <TableCell align="right">
                          {safeDisplay(invoiceData.order?.grossAmount)} {safeDisplay(invoiceData?.currencyCode)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Toplam İndirim</TableCell>
                        <TableCell align="right">
                          {safeDisplay(invoiceData.order?.totalDiscount)} {safeDisplay(invoiceData?.currencyCode)}
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </BorderedPaper>
          </Box>

          {/* Note Section */}
          {invoiceData.note && (
            <BorderedPaper sx={{ mt: 2 }}>
              <Typography variant="h6">Not</Typography>
              <Typography>{invoiceData.note}</Typography>
            </BorderedPaper>
          )}

          {/* Signature Area */}
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <BorderedPaper>
                <Typography variant="h6" align="center" sx={{ borderBottom: '1px solid black', pb: 1 }}>
                  Teslim Eden
                </Typography>
                <Box sx={{ height: 100 }} />
              </BorderedPaper>
            </Grid>
            <Grid item xs={6}>
              <BorderedPaper>
                <Typography variant="h6" align="center" sx={{ borderBottom: '1px solid black', pb: 1 }}>
                  Teslim Alan
                </Typography>
                <Box sx={{ height: 100 }} />
              </BorderedPaper>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}